/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Camera_Gps_RequiredInputs */

const vi_vehicle_camera_gps_required = /** @type {(inputs: Vehicle_Camera_Gps_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cần cấu hình GPS cho xe trước khi xem camera.`)
};

/**

* @param {Vehicle_Camera_Gps_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_camera_gps_required = /** @type {((inputs?: Vehicle_Camera_Gps_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Camera_Gps_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_camera_gps_required(inputs)
});